import { swipeCode } from "./HardCode.js";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import Quality from "../Quality/Quality";
import { useSelector } from "react-redux";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice.js";
import "swiper/css";
import "swiper/css/pagination";

const Swipers = () => {
  const selectedLanguages = useSelector(selectedLanguage);
  return (
    <Swiper
      pagination={{
        dynamicBullets: true,
      }}
      autoplay={{
        delay: 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }}
      autoHeight={true}
      loop={true}
      speed={1000}
      modules={[Pagination, Autoplay]}
      className="mySwiper"
      style={{ backgroundColor: "white" }}
    >
      {swipeCode[`${selectedLanguages}`].map((el, idx) => {
        return (
          <SwiperSlide key={idx}>
            <Quality title={el.title} desc={el.desc} user={el.user} img={el.img} />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default Swipers;
